import Base from './CustomerListOverview.vue'
import View from './CustomerListDetail.vue'
import Users from './CustomerUsers.vue'

export default {
    Base,
    View,
    Users
}


// WEBPACK FOOTER //
// ./src/views/salesman/customerList/index.js